import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../../Header/Header";
import uni from   '../../../../assets/img/univ.png'
import './wishlist.css'
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import "./WishListChatCard.css";
import {
  applyUniversity,
  deleteApplication,
  deleteWishlist,
  getAllUserApplications,
  getAllUserApplicationsBasedOnStatus,
  getAllWishlistUniversities,
  updateApplication,
} from "../../../HttpRequest/applyapplication";
import Pagination from "../../Base UI/Pagination";
import {
  WarningAlert,
  applicationWithDraw,
  cancelButton,
} from "../../Base UI Elements/SweetAlert";
import ModelUpload from "../../../ModelUpload";
import Card from "./Card";
import { Tag } from "antd";

export default function WishList(passingUserId) {
  const [userIdWishlist, setuserIdWishlist] = useState([]);
  const [data, setData] = useState([]);
  const [application, setApplication] = useState();
  const [popup, setPopup] = useState(false);
  const [pagedata, setpagedata] = useState();
  const [checkedIndex, setCheckedIndex] = useState(1);
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 20,
  });

  const fetchData = async () => {
    let userId ="";
    try {
      if(localStorage.getItem("userRole") === "admin"){
        const id = passingUserId.location.state;
        userId = id.passingUserId;
        console.log("userId in the wishlist==>",userId);
      }else{
        userId = localStorage.getItem("id");
      }
      const response = getAllWishlistUniversities(
        userId,
        pageInfo.page,
        pageInfo.size
      );
      response.then((data) => {
        console.log("User applied applications===>", data);
        if (data.request.status == 200) {
          setpagedata(data.metaData);
          setData(data.data);
          setCheckedIndex(1);
        } else {
          console.log("data error");
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [passingUserId,pageInfo]);

  const setPopUpClose = (data) => {
    console.log("pop up close is calling-->",data)
    setPopup(data);
  };

  const setPageInfoData = (data) => {
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };
  const applyUniversityInWishlist = (masterDataEntityId, userId) => {
    try {
      let application = {
        userId: userId,
        status: "application-requested",
        masterDataEntityId: masterDataEntityId,
      };
      applyUniversity(application).then((response) => {
        if (response.status = 201) {
          console.log("response of apply in wishlist==>", response);
          setApplication(response.data);
          setPopup(true);
        } else {
          WarningAlert(
            "Unable to apply. Please contact the support team.",
            "/admindashboard"
          );
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const deleteWishlistFunction = async (id) => {
    cancelButton(async (userClickedYes) => {
      if (userClickedYes) {
        try {
          console.log("delete is calling-->", id);
          const response = await deleteWishlist(id);
          console.log("delete is done...!", response);
          if (response.status === 204) {
            console.log("delete is successful!");
            fetchData();
          } else {
            console.log("data error");
          }
        } catch (error) {
          console.error("Error during delete:", error);
        }
      } else {
        console.log("User clicked No or dismissed the dialog");
      }
    });
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title mt-2">My Wishlist </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">My Wishlist</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="card card-table">
              <div className="card-body">
                <div className="row col-12">
                  <div className="chatgrop" >
              
{/* 
              <Card  data={data}/> */}
              {/* <Card />
              <Card />
              <Card />  */}

{data.data?.map((item) => (
        <div class="product-card" key={item.applicationId}>
		<div class="badge">
			{/* App ID :  */}
			Wishlist Id: {item.wishListId}
			</div>
		<div class="product-tumb">
			<img src={uni} alt=""  />
		</div>
		<div class="product-details">
			<span class="product-catagory">Application Id : {item.wishListId}</span>
			<h6><a href="">   {item.name}</a></h6>
			<p> <i class="fa-solid fa-graduation-cap fw-bold"   style={{color:'blue'}}></i>{" "}        {item.university}</p>

          <p style={{marginTop: '-6px', color:'blue'}}> Status : <Tag  color="var(--bs-danger)" style={{fontWeight:'500'}}>Application-pending</Tag> </p>
			<div class="product-bottom-details mb-2">
				<div class="product-price "  style={{color:'blue' , fontWeight:400,fontSize:'16px'}}> 
        {/* Apply <i class="fa-solid fa-comment"     ></i>     <small>         
                    </small> */}
                    {/* $230.99 */}
                    <button  className='buttoncomponent'   
                     onClick={() =>
                      applyUniversityInWishlist(
                        item.masterDataEntityId,
                        item.userId
                      )
                    }>Apply</button>    
                    </div>
                  
				<div class="product-links">   
					{/* <a href=""><i class="fa-solid fa-comment"></i></a> */}
					<a  onClick={() => deleteWishlistFunction(item.id)}  ><i class="fa-solid fa-trash"></i></a>
				</div>
			</div>
		</div>
	</div>    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {pagedata && (
            <Pagination
              pageResponce={pagedata}
              pagedataToParent={setPageInfoData}
            />
          )}
          {popup && (
            <ModelUpload
              applicationobj={application}
              closePopup={setPopUpClose}
            />
          )}
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
}
